// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__2Jg7i","head":"ProcedureTableInfo_head__2WQwh"};